import React from "react";
import './infoListStyle.css';

const InfoList = ({ headerTitle, subTitle, infoList }) => {
	return (
		<div className='list-container'>
			<div className='uni-h-wrap'>
				<h3 className='ui-h3'>{headerTitle}</h3>
				<h4 className='list-subtitle'>{subTitle}</h4>
			</div>
			<br />
			<div className='info-list_container'>
				{ infoList.map( (infoItem, indx) => {
					return (
						<div key={infoItem.title}>
							<h4 className='ui-h4'>{indx+1}. {infoItem.title}</h4>
							<p className='description_text'>{infoItem.description}</p>
						</div>
					);  
				})} 
			</div>
		</div>
	)
}

export default InfoList;